import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Product Runway ")
const _hoisted_2 = { id: "main" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Unable to communicate with the server. Please check your connection. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Menubar = _resolveComponent("Menubar")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Toast = _resolveComponent("Toast")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Button = _resolveComponent("Button")!

  return (_ctx.appLaunchDataStatus === 'loaded')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_Menubar, { model: _ctx.menubarItems }, {
          start: _withCtx(() => [
            _createVNode(_component_RouterLink, { to: { name: 'home' } }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("main", _hoisted_2, [
          _createVNode(_component_RouterView),
          _createVNode(_component_ConfirmDialog),
          _createVNode(_component_Toast, { position: "bottom-center" })
        ])
      ], 64))
    : (_ctx.appLaunchDataStatus === 'loading')
      ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
          key: 1,
          class: "d-block"
        }))
      : (_ctx.appLaunchDataStatus === 'error')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(_component_Message, {
              severity: "error",
              closable: false
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              label: "Try Again",
              onClick: _ctx.loadAppLaunchData
            }, null, 8, ["onClick"])
          ], 64))
        : _createCommentVNode("", true)
}